export default {
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    colorDisabled: {
      type: String,
      default: '#263b1e',
    },
    color: {
      type: String,
      default: '#000000',
    },
    name: {
      type: String,
      required: true,
    },
    checked: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: true,
    };
  },
  computed: {
    classModifiers() {
      return {
        'charts-checkbox': true,
        'charts-checkbox--checked': this.checked,
      };
    },
    tickClassModifiers() {
      return {
        'charts-checkbox__tick': true,
        'charts-checkbox__tick--checked': this.checked,
      };
    },
    styleModifiers() {
      const color = this.checked ? this.color : this.colorDisabled;
      return {
        border: `solid 2px ${color}`,
      };
    },
  },
  methods: {
    onChange(e) {
      this.show = false;
      this.$emit('change', e.target.checked);
      setTimeout(() => { this.show = true; }, 0);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-detail-charts/checkbox/checkbox.js